import { requireNativeModule } from 'expo-modules-core';

// Load the native module by its correct name
export default requireNativeModule('PcmProcessor');